import Action from '@/models/action'

const actionProviderMixin = {

  props: {
    action: {
      type: Action,
      required: true
    }
  },

  methods: 
  {
    onCompleted(data)
    {
      this.$emit('completed', data)
    }
  },

  computed:
  {
    
  },

  watch:
  {
    
  }
}

export default actionProviderMixin